export default function getObjectPathProperty(object, path) {
    if(typeof object !== 'object') {
        return false;
    }
    path = path.split('.');
    let index = - 1, length = path.length;
    while (object !== undefined && index < length) {

        object = object[path[++index]];
    }
    return index && index === length;
}
